<template>
  <div class="h-auto rounded-lg box p-2 w-64 mt-2">
        <div class="header vx-row justify-between flex-1">
            <div class="vx-col">
                <vs-checkbox v-model="isChecked" @click="$emit('input', !isChecked ? vsValue : null)"></vs-checkbox>
            </div>
            <div class="vx-col font-bold">
                <span>{{label}}</span>
            </div>
        </div>
        <div class="mt-8">
            <span>{{text}}</span>
        </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    checked: Boolean,
    text: String,
    index: Number,
    value: '',
    "vsValue": null
  },

  data () {
      return {
          isChecked: false
      }
  },

  created () {
      this.isChecked = this.vsValue === this.value
  },

  watch: {
      value (newValue) {
          setTimeout(() => {
             this.isChecked = this.vsValue === newValue;
          }, 1)
      },
  },
};
</script>

<style scoped>
    .box {
        border: 1px #ccc solid;
    }
</style>